import React, { useRef, useState } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, Box, Stack, IconButton, Tooltip } from '@mui/material';
import { QRCodeCanvas } from 'qrcode.react';
import QrCodeIcon from '@mui/icons-material/QrCode';
const QRCodeButton = ({ variantId }) => {
    const [open, setOpen] = useState(false);
    const qrRef = useRef();

    const qrValue = variantId;

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleDownload = () => {
        const canvas = qrRef.current.querySelector('canvas');
        if (canvas) {
            const url = canvas.toDataURL('image/png');
            const link = document.createElement('a');
            link.href = url;
            link.download = `tendenec_qrcode_variant_${variantId}.png`;
            link.click();
        }
    };

    return (
        <>
            <Tooltip title={'QRコード生成'}>
                <IconButton color="primary" onClick={handleOpen}>
                    <QrCodeIcon />
                </IconButton>
            </Tooltip >
            <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
                <DialogTitle>QRコード</DialogTitle>
                <DialogContent>
                    <Box
                        ref={qrRef}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        my={2}
                    >
                        <QRCodeCanvas value={qrValue} size={200} />
                    </Box>

                    <Stack direction="row" justifyContent="center" spacing={2} mb={2}>
                        <Button variant="contained" onClick={handleDownload}>
                            ダウンロード
                        </Button>
                        <Button variant="outlined" onClick={handleClose}>
                            閉じる
                        </Button>
                    </Stack>
                </DialogContent>
            </Dialog>
        </>
    );
}
export default QRCodeButton;
